import React from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BrandLogo from "./BrandLogo";
import NavMenu from "./NavMenu";
import UserDropdown from "./UserDropdown";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../../../Redux/Slices/uiSlice";
import useWindowWidth from "../../../../Hooks/useWindow";
const PropertyHeader = () => {
    const [toggle, setToggle] = React.useState(true);
    const navigate = useNavigate();
    const width = useWindowWidth()
    const projectType = useSelector((state) => state.uiReducers.appType) || "Business";
    const dispatch = useDispatch();
    const handleLogout = () => {
        sessionStorage.removeItem("loggedInUser");
        sessionStorage.removeItem("Apptype");
        navigate("/login", { replace: true });
    };
    const handleToggle = async (e) => {
        e.preventDefault();
        const newMode = projectType === "Ecommerce" ? "Business" : "Ecommerce";
        const result = await Swal.fire({
            title: `Switch to ${newMode} Mode?`,
            text: "This will change the layout and features of the application.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, switch it!",
            cancelButtonColor: "red",
            confirmButtonColor: "green"
        });
        setToggle((toggle) => !toggle);
        if (result.isConfirmed) {
            sessionStorage.setItem("Apptype", newMode);
            dispatch(uiAction.updateAppType(newMode));
            setToggle((toggle) => !toggle);
            navigate("/dashboard", { replace: true });// Redirect to home or any other page
        }
        if (result.isDismissed) {
            setToggle((toggle) => !toggle);
        }
    };

    return (
        <>
            <nav style={{ zIndex: "99" }} className="navbar bg-nav navbar-top navbar-slim justify-content-between fixed-top navbar-expand-lg  bg-gradient" id="navbarTopSlim" data-navbar-appearance="darker">
                <div className="test-mode"><span>Test Mode</span></div>
                <BrandLogo />
                {/* <div className="form-check form-switch text-white">
                    <span style={width > 1280 ? {} : { display: "none" }} className="ms-2 fw-semibold text-white nav-color">{projectType !== "Ecommerce" ? "Property Dashboard" : "Ecommerce"}</span>
                    <input checked={toggle} onChange={handleToggle} className="form-check-input" type="checkbox" id="themeToggle" />
                </div> */}
                <div className="navbar-collapse navbar-top-collapse order-1 order-lg-0 justify-content-center">
                    <NavMenu />
                </div>
                {/* <NotificationDropdown /> */}
                <UserDropdown onLogout={handleLogout} />
            </nav>
        </>
    );
};

export default PropertyHeader;


